import React, { useEffect, useState } from "react";
import { IAboutDescriptionData, IBannerData, IObjectiveData } from "../exports/interfaces";
import { dynamicFailed } from "../hooks/useToast";
import { useLoader } from "../context/LoaderContext";
import AboutBanner from "../components/about/AboutBanner";
import { fetchAboutBanner, fetchAboutDescriptionBanner, fetchKeyObjectives, fetchObjectivesTrust } from "../api/AboutApi";
import AboutDescription from "../components/about/AboutDescription";
import AboutObjective from "../components/about/AboutObjective";

const About = () => {
  const { setLoading } = useLoader();
  const [aboutDescriptionData, setAboutDescriptionData] = useState<IAboutDescriptionData[]>([]);
  const [aboutBannerData, setAboutBannerData] = useState<
    IBannerData[]
  >([]);
  const [keyObjectivesData, setKeyObjectivesData] = useState<IObjectiveData[]>([]);
  const [objectivesTrustData, setObjectivesTrustData] = useState<IObjectiveData[]>([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchAboutBanner(), fetchAboutDescriptionBanner(), fetchKeyObjectives(), fetchObjectivesTrust()])
      .then(([aboutBannerData, aboutDescriptionData, keyObjectivesData, objectivesTrustData]) => {
        setAboutBannerData(aboutBannerData);
        setAboutDescriptionData(aboutDescriptionData);
        setKeyObjectivesData(keyObjectivesData);
        setObjectivesTrustData(objectivesTrustData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <AboutBanner aboutBannerData={aboutBannerData} />
      <AboutDescription aboutDescriptionData={aboutDescriptionData}/>
      <AboutObjective keyObjectivesData={keyObjectivesData} objectivesTrustData={objectivesTrustData}/>
    </>
  );
};

export default About;
